/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StepDTO { 
    id?: number;
    template?: string;
    days?: number;
    hours?: number;
    basedOn?: StepDTO.BasedOnEnum;
    otherStep?: number;
    startWhen?: StepDTO.StartWhenEnum;
    autoCompletionType?: StepDTO.AutoCompletionTypeEnum;
    notifyCustomer?: StepDTO.NotifyCustomerEnum;
    notifyCustomerText?: string;
    customerNotifiedOn?: Date;
    isBlocked?: boolean;
    masterDataStatus?: StepDTO.MasterDataStatusEnum;
}
export namespace StepDTO {
    export type BasedOnEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 40 | 41 | 42 | 43 | 44 | 45 | 46 | 47 | 48;
    export const BasedOnEnum = {
        NUMBER_0: 0 as BasedOnEnum,
        NUMBER_1: 1 as BasedOnEnum,
        NUMBER_2: 2 as BasedOnEnum,
        NUMBER_3: 3 as BasedOnEnum,
        NUMBER_4: 4 as BasedOnEnum,
        NUMBER_5: 5 as BasedOnEnum,
        NUMBER_6: 6 as BasedOnEnum,
        NUMBER_7: 7 as BasedOnEnum,
        NUMBER_8: 8 as BasedOnEnum,
        NUMBER_9: 9 as BasedOnEnum,
        NUMBER_10: 10 as BasedOnEnum,
        NUMBER_11: 11 as BasedOnEnum,
        NUMBER_12: 12 as BasedOnEnum,
        NUMBER_13: 13 as BasedOnEnum,
        NUMBER_14: 14 as BasedOnEnum,
        NUMBER_15: 15 as BasedOnEnum,
        NUMBER_16: 16 as BasedOnEnum,
        NUMBER_17: 17 as BasedOnEnum,
        NUMBER_18: 18 as BasedOnEnum,
        NUMBER_19: 19 as BasedOnEnum,
        NUMBER_20: 20 as BasedOnEnum,
        NUMBER_21: 21 as BasedOnEnum,
        NUMBER_22: 22 as BasedOnEnum,
        NUMBER_23: 23 as BasedOnEnum,
        NUMBER_24: 24 as BasedOnEnum,
        NUMBER_25: 25 as BasedOnEnum,
        NUMBER_26: 26 as BasedOnEnum,
        NUMBER_27: 27 as BasedOnEnum,
        NUMBER_28: 28 as BasedOnEnum,
        NUMBER_29: 29 as BasedOnEnum,
        NUMBER_30: 30 as BasedOnEnum,
        NUMBER_31: 31 as BasedOnEnum,
        NUMBER_32: 32 as BasedOnEnum,
        NUMBER_33: 33 as BasedOnEnum,
        NUMBER_34: 34 as BasedOnEnum,
        NUMBER_35: 35 as BasedOnEnum,
        NUMBER_36: 36 as BasedOnEnum,
        NUMBER_37: 37 as BasedOnEnum,
        NUMBER_38: 38 as BasedOnEnum,
        NUMBER_39: 39 as BasedOnEnum,
        NUMBER_40: 40 as BasedOnEnum,
        NUMBER_41: 41 as BasedOnEnum,
        NUMBER_42: 42 as BasedOnEnum,
        NUMBER_43: 43 as BasedOnEnum,
        NUMBER_44: 44 as BasedOnEnum,
        NUMBER_45: 45 as BasedOnEnum,
        NUMBER_46: 46 as BasedOnEnum,
        NUMBER_47: 47 as BasedOnEnum,
        NUMBER_48: 48 as BasedOnEnum
    };
    export type StartWhenEnum = 0 | 1;
    export const StartWhenEnum = {
        NUMBER_0: 0 as StartWhenEnum,
        NUMBER_1: 1 as StartWhenEnum
    };
    export type AutoCompletionTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
    export const AutoCompletionTypeEnum = {
        NUMBER_0: 0 as AutoCompletionTypeEnum,
        NUMBER_1: 1 as AutoCompletionTypeEnum,
        NUMBER_2: 2 as AutoCompletionTypeEnum,
        NUMBER_3: 3 as AutoCompletionTypeEnum,
        NUMBER_4: 4 as AutoCompletionTypeEnum,
        NUMBER_5: 5 as AutoCompletionTypeEnum,
        NUMBER_6: 6 as AutoCompletionTypeEnum,
        NUMBER_7: 7 as AutoCompletionTypeEnum
    };
    export type NotifyCustomerEnum = 0 | 1 | 2 | 3;
    export const NotifyCustomerEnum = {
        NUMBER_0: 0 as NotifyCustomerEnum,
        NUMBER_1: 1 as NotifyCustomerEnum,
        NUMBER_2: 2 as NotifyCustomerEnum,
        NUMBER_3: 3 as NotifyCustomerEnum
    };
    export type MasterDataStatusEnum = 0 | 1;
    export const MasterDataStatusEnum = {
        NUMBER_0: 0 as MasterDataStatusEnum,
        NUMBER_1: 1 as MasterDataStatusEnum
    };
}